import { render, staticRenderFns } from "./orderListComponent.vue?vue&type=template&id=4040723a&scoped=true&"
import script from "./orderListComponent.vue?vue&type=script&lang=js&"
export * from "./orderListComponent.vue?vue&type=script&lang=js&"
import style0 from "./orderListComponent.vue?vue&type=style&index=0&id=4040723a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4040723a",
  null
  
)

export default component.exports